import React from "react";

/**
 * Reusable filter pill toggle bar (e.g. All | Weekly | Monthly or Today | 1W | 1M | Custom)
 *
 * @param {Array<{label: string, value: string}>} options - List of filter items
 * @param {string} activeValue - The currently selected filter value
 * @param {function} onChange - Callback when an item is selected (value) => void
 * @param {function} [renderLabel] - Optional custom label renderer function (option, isActive) => ReactNode
 * @param {function} [isOptionActive] - Optional custom active check function (option, activeValue) => boolean
 * @param {function} [getOptionClassName] - Optional extra class generator (option, isActive) => string
 * @param {string} [className] - Optional wrapper class name suffix
 */
export default function PillFilter({
  options = [],
  activeValue,
  onChange,
  renderLabel,
  isOptionActive,
  getOptionClassName,
  className = "",
}) {
  return (
    <div className={`utc-header-filtering ${className}`.trim()}>
      {options.map((option) => {
        const isActive = isOptionActive
          ? isOptionActive(option, activeValue)
          : activeValue === option.value;

        const extraClass = getOptionClassName
          ? getOptionClassName(option, isActive)
          : "";

        return (
          <div
            key={option.value}
            className={`utc-header-filtering-item ${
              isActive ? "active" : ""
            } ${extraClass}`.trim()}
            onClick={() => onChange(option.value)}
            style={{ cursor: "pointer" }}
          >
            {renderLabel ? renderLabel(option, isActive) : option.label}
          </div>
        );
      })}
    </div>
  );
}
